/* Local dependencies */
import { Order, OrderStatus } from '../../../shared/types';

export enum UpdateOrderActionTypes {
  UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST',
  UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS',
  UPDATE_ORDER_ERROR = 'UPDATE_ORDER_ERROR',
  RESET_ERROR = 'RESET_UPDATE_ORDER_ERROR',
}

export interface UpdateOrderInput {
  id: string;
  status?: OrderStatus;
}

export interface UpdateOrderRequest {
  type: UpdateOrderActionTypes.UPDATE_ORDER_REQUEST;
  input: UpdateOrderInput;
}

export interface UpdateOrderSuccess {
  type: UpdateOrderActionTypes.UPDATE_ORDER_SUCCESS;
  order: Order;
}

export interface UpdateOrderError {
  type: UpdateOrderActionTypes.UPDATE_ORDER_ERROR;
  error: Error;
}

export interface ResetError {
  type: UpdateOrderActionTypes.RESET_ERROR;
}

export type UpdateOrderAction = UpdateOrderRequest | UpdateOrderSuccess | UpdateOrderError | ResetError;

